import { Pipe, PipeTransform } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';

@Pipe({
  name: 'orderValue',
  standalone: true,
})
export class OrderValuePipe implements PipeTransform {
  public transform(order: OrderData, valueType: 'open' | 'filled' | 'canceled', quoteToUse?: number | undefined): number | undefined {
    if (!order) {
      return undefined;
    }

    const calcPrice: number = this.#getCalcPrice(order, quoteToUse);

    let orderValue = 0;
    switch (valueType) {
      case 'filled':
        orderValue = order.executedQuantity * order.execPrice;
        break;
      case 'open': {
        const { fixedRemainingAmount, execType, direction } = order;
        const isFractionBuyOrderWithFixedRemainingAmount =
          execType === 'fraction' && direction === 'buy' && !Number.isNaN(fixedRemainingAmount) && fixedRemainingAmount > 0;
        if (isFractionBuyOrderWithFixedRemainingAmount) {
          orderValue = order.fixedRemainingAmount;
        } else if (order.execType === 'savings') {
          orderValue = order.blockedBP > 0 ? order.blockedBP : order.quantity * calcPrice;
        } else {
          orderValue = order.openQuantity * calcPrice;
        }
        break;
      }
      default:
        orderValue = (order.quantity - order.executedQuantity) * calcPrice;
        break;
    }

    if (order.direction === 'buy') {
      orderValue *= -1;
    }

    return Number.isNaN(orderValue) ? undefined : orderValue;
  }

  #getCalcPrice(order: OrderData, quoteToUse?: number | undefined): number {
    const { execType } = order;
    switch (execType) {
      case 'market':
      case 'savings':
      case 'fraction':
        return quoteToUse || order.quote;
      case 'limit':
      case 'stoplimit':
        return order.limitPrice;
      case 'stop':
        return order.stopPrice;
      case 'tsl':
        return order.latestTslStop ?? order.stopPrice;
      default:
        break;
    }
    return 0;
  }
}
